import { Link } from 'react-router-dom';
import heartFill from '../../assest/images/heart-fill.png';
import heart from '../../assest/images/heart.png';
import SKProductList from '../../components/Skeletons/SKProductList';
import TableRecordNotFound from '../../components/TableRecordNotFound';
import noTour from "../../assest/myImages/no-tour-img.png";
import helper, { formatMeetingLocation, getSlugByLang, getSlugNameByLang } from '../../common/Helper';
import { Pagination as RecordPagination } from '../../components/Pagination';
import Empty from './Empty';
import { useSelector } from 'react-redux';
const Index = ({
    currentPage,
    productList,
    isLoading,
    totalItems,
    totalPages,
    onPageChange,
    toggleLike
}) => {
    const user = useSelector((state) => state.user);
    const slugField = getSlugNameByLang(user?.language)

    const slugLang = getSlugByLang(user?.language)

    return (
        <div className="exploreTour">
            {
                isLoading ?
                    <SKProductList records={5} /> :
                    <>
                        {
                            productList.length > 0 ?
                                productList.map((product, i) => {
                                    let amt = '';
                                    if (product.product_rate_pricing_categories && product.product_rate_pricing_categories.length > 0) {
                                        amt = product.product_rate_pricing_categories[0].lowest_amount;
                                    } else if (product.product_rate_tiered_pricing_categories && product.product_rate_tiered_pricing_categories.length > 0) {
                                        amt = product.product_rate_tiered_pricing_categories[0].lowest_amount;
                                    }
                                    return (
                                        <Link
                                            // to={'/tour/' + product.slug} 
                                            style={{ width: "100%" }}
                                            to={(slugLang ? ('/' + slugLang) : '') + '/tour/' + product?.[slugField]}
                                        >
                                                <div className="ourTourBox" key={i}>
                                                    <div className="leftImg">
                                                        <img
                                                            // src={helper.S3Url + '/' + helper.productImageDir + '/thumbnail/' + product.cover_image}
                                                            src={helper.S3Url + '/' + helper.productImageDir + '/' + product.cover_image}

                                                            alt={product?.cover_image_alternate_text}
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = noTour
                                                            }}
                                                        />
                                                    </div>


                                                    <div className="rightText">
                                                        <div className="card_top_content">
                                                            <div className="fillBox">
                                                                <p><i className="fa-solid fa-location-dot"></i>
                                                                    {/* {product.address ? product.address : '-'} */}
                                                                    {product?.product_detail?.meeting_point_location ?
                                                                        formatMeetingLocation(product?.product_detail?.meeting_point_location) :
                                                                        product?.product_detail?.location ?
                                                                            formatMeetingLocation(product?.product_detail?.location)
                                                                            : (product?.address ? product?.address : "-")}
                                                                </p>
                                                                <div className="wishClik">
                                                                    <a href="javascript:void(0)"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation(); // Prevent the Link from triggering
                                                                            toggleLike(product.id);
                                                                        }}
                                                                    >

                                                                        <img src={heartFill} alt="heart-fill" />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            <h5
                                                                // data-bs-toggle="tooltip" data-bs-placement="top"
                                                                // data-bs-custom-className="custom-tooltip"
                                                                // data-bs-title="This top tooltip is themed via CSS variables."
                                                                title={product.title}>{product.title}</h5>
                                                            {
                                                                product?.short_description &&
                                                                <p className="min_height twoLine">{product?.short_description}</p>
                                                            }
                                                            <ul>
                                                                {
                                                                    product.product_rates.filter((e) => e.availability_seat_type == 'non_private').length > 0 &&
                                                                    <li><p><i className="fa-solid fa-user-group"></i> Groups</p></li>
                                                                }
                                                                {
                                                                    product.product_rates.filter((e) => e.availability_seat_type == 'private').length > 0 &&
                                                                    <li><p><i className="fa-solid fa-user"></i> Private</p></li>
                                                                }
                                                                {
                                                                    product?.duration &&
                                                                    <li><p><i className="fa-solid fa-clock"></i> {product.duration}</p></li>
                                                                }
                                                            </ul>
                                                        </div>
                                                        <div className="priceBox">
                                                            <h6>{amt ? 'From € ' + amt : ''}</h6>
                                                            {
                                                                product?.product_detail?.trustindex_rating != null &&

                                                                <div
                                                                    className='filterpagereview'
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: product?.product_detail?.trustindex_rating
                                                                    }}
                                                                />
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                        </Link>
                                    )
                                })
                                : <Empty />
                        }
                        {
                            productList.length > 0 &&
                            <RecordPagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={onPageChange}
                                totalItems={totalItems}
                            />
                        }
                    </>



            }

        </div>
    )

}
export default Index;